module.exports = ".rim{\r\n    padding-top: 60px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/selectable-tabs/expert-screen-components/expert-rim/expert-rim.component.css
// module id = ./src/app/components/selectable-tabs/expert-screen-components/expert-rim/expert-rim.component.css
// module chunks = main